type EventLocationInput = {
  city?: {
    name?: string | null;
    countrySubdivision?: { code?: string | null; name?: string | null } | null;
  } | null;
  displayLocation?: string | null;
  addressString?: string | null;
  venue?: { addressString?: string | null } | null;
};

function isValidLocation(value: string | null | undefined): value is string {
  return !!value && !value.includes('undefined') && !value.includes('null');
}

/**
 * Returns the best available human-readable location string for an event/tournament.
 * Priority: city+subdivision > displayLocation > venue.addressString > addressString
 */
export function getEventLocation(event: EventLocationInput): string {
  if (event.city?.name && event.city?.countrySubdivision?.code) {
    return `${event.city.name}, ${event.city.countrySubdivision.code}`;
  }
  if (isValidLocation(event.displayLocation)) return event.displayLocation;
  return event.venue?.addressString || event.addressString || '';
}
